module.exports = "/_next/static/images/image1-3852673e3a8d572cddc9497d68d0a5a7.png";